import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { setValueAndMaxLength } from "../../utils/setValueAndMaxLenght";
import editPencil from "../../assets/edit-pencil.svg";
import checkMark from "../../assets/check-mark.svg";
import exit from "../../assets/exit-orange-thick.svg";

const IntakeInput = (props) => {
  const todays_intake = useSelector((state) => state.nutritionReducer.todays_intake);
  const todays_intake_demo = useSelector((state) => state.demoReducer.todays_intake_demo);
  const demo = useSelector((state) => state.demoReducer.demo);
  const activeList = demo ? todays_intake_demo : todays_intake;
  const inputRef = useRef(null);
  const [editGoal, setEditGoal] = useState(false);
  const [updatedGoal, setUpdatedGoal] = useState(inputRef.current != null && inputRef.current.value);

  // Sums up each nutrient from the currently active list
  const calculatedNutrition = activeList.map((item) => Number(item[props.name])).reduce((a, b) => a + b, 0);

  // Focuses input when we click the edit input button
  useEffect(() => {
    if (editGoal) {
      inputRef.current != null && inputRef.current.focus();
    }
  }, [editGoal]);

  // Handles the nutrient goal submit
  const handleNutrientGoalSubmit = () => {
    setEditGoal(false);
    props.onChange(inputRef.current.value);
  };

  // Handles the nutrient goal dismiss
  const handleNutrientGoalDismiss = () => {
    setEditGoal(false);
  };

  return (
    <li className="intake__nutrient">
      <p className="intake__nutrient-title">{props.name}</p>
      <p className="intake__nutrient-amount">
        {editGoal ? (
          <>
            {calculatedNutrition}
            <span className="intake__nutrient-goal-seperator">/</span>
            <input
              className="intake__nutrient-goal-input"
              type="number"
              value={updatedGoal}
              ref={inputRef}
              onChange={(e) => {
                setValueAndMaxLength(e, setUpdatedGoal, 4);
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  setEditGoal(false);
                  props.onChange(inputRef.current.value);
                }
                if (e.keyCode === 27) {
                  setEditGoal(false);
                }
              }}
              style={{
                width: `calc((${updatedGoal.toString().length}ch) + 1px)`,
              }}
            />
            <span className="intake__nutrient-goal-unit">{props.unit}</span>
          </>
        ) : (
          <>
            {calculatedNutrition}
            <span className="intake__nutrient-goal-seperator">/</span>
            {props.goal}
            <span
              className={
                editGoal
                  ? "intake__nutrient-goal-unit"
                  : "intake__nutrient-goal-unit intake__nutrient-goal-unit--active"
              }
            >
              {props.unit}
            </span>
          </>
        )}
        {editGoal ? (
          <>
            <img
              src={checkMark}
              className="intake__nutrient-goal-submit intake__nutrient-goal-img"
              alt="submit"
              onClick={handleNutrientGoalSubmit}
            />
            <img
              src={exit}
              className="intake__nutrient-goal-dismiss intake__nutrient-goal-img"
              alt="dismiss"
              onClick={handleNutrientGoalDismiss}
            />
          </>
        ) : (
          <img
            src={editPencil}
            className="intake__nutrient-goal-edit intake__nutrient-goal-img"
            alt="edit"
            onClick={() => {
              setEditGoal(true);
              setUpdatedGoal(props.goal);
            }}
          />
        )}
      </p>
    </li>
  );
};

export default IntakeInput;
